module.exports = __webpack_public_path__ + "img/twitter-share-icon.0bbcf316.svg";